// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d7806d2","239":"30759cb9","732":"0c1a9e13"}[chunkId] + ".chunk.js";
};